export const userConstants = {
    REGISTER_REQUEST: 'USERS_REGISTER_REQUEST',
    REGISTER_SUCCESS: 'USERS_REGISTER_SUCCESS',
    REGISTER_FAILURE: 'USERS_REGISTER_FAILURE',

    LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',
    LOY3_LOGIN_SUCCESS: 'LOY3_LOGIN_SUCCESS',
    LOY3_LOGIN_FAILURE: 'LOY3_LOGIN_FAILURE',
    LOY3_SSO_LOGIN_FAILURE: 'LOY3_SSO_LOGIN_FAILURE',
    LOY3_LOAD_DATA_SUCCESS: 'LOY3_LOAD_DATA_SUCCESS',
    LOY3_REGISTER_SUCCESS: 'LOY3_REGISTER_SUCCESS',
    LOY3_REGISTER_FAILED: 'LOY3_REGISTER_FAILED',
    LOY3_NEW_PASSWORD_SUCCESS: 'LOY3_NEW_PASSWORD_SUCCESS',
    LOY3_LOAD_DATA_FAILURE: 'LOY3_LOAD_DATA_FAILURE',
    LOY3_GET_BRAND_ID_SUCCESS: 'LOY3_GET_BRAND_ID_SUCCESS',
    LOY3_GET_BRAND_ID_FAILURE: 'LOY3_GET_BRAND_ID_FAILURE',
    LOY3_GET_BRAND_SUCCESS: 'LOY3_GET_BRAND_SUCCESS',
    LOY3_GET_BRAND_FAILURE: 'LOY3_GET_BRAND_FAILURE',
    LOY3_GET_BOOKINGS_SUCCESS: 'LOY3_GET_BOOKINGS_SUCCESS',
    LOY3_GET_BOOKINGS_FAILURE: 'LOY3_GET_BOOKINGS_FAILURE',
    LOY3_FIND_BOOKING_SUCCESS: 'LOY3_FIND_BOOKING_SUCCESS',
    LOY3_FIND_BOOKING_FAILURE: 'LOY3_FIND_BOOKING_FAILURE',
    LOY3_CLAIM_BOOKING_SUCCESS: 'LOY3_CLAIM_BOOKING_SUCCESS',
    LOY3_CLAIM_BOOKING_FAILURE: 'LOY3_CLAIM_BOOKING_FAILURE',
    LOY3_CLAIM_BOOKING_WITH_PDF_SUCCESS: 'LOY3_CLAIM_BOOKING_WITH_PDF_SUCCESS',
    LOY3_CLAIM_BOOKING_WITH_PDF_FAILURE: 'LOY3_CLAIM_BOOKING_WITH_PDF_FAILURE',
    LOY3_GET_FRIENDS_SUCCESS: 'LOY3_GET_FRIENDS_SUCCESS',
    LOY3_GET_FRIENDS_FAILURE: 'LOY3_GET_FRIENDS_FAILURE',
    LOY3_INVITE_FRIEND: 'LOY3_INVITE_FRIEDS',
    LOY3_TRANSFER_POINTS_FAILURE: 'LOY3_TRANSFER_POINTS_FAILURE',
    LOY3_REDEEM_COINS_SUCCESS: 'LOY3_REDEEM_COINS_SUCCESS',
    LOY3_REDEEM_COINS_FAILURE: 'LOY3_REDEEM_COINS_FAILURE',
    LOY3_SET_BRAND_CONSTANTS: 'LOY3_SET_BRAND_CONSTANTS',

    STORE_USER: 'STORE_USER',

    LOY3_LOAD_CART_SUCCESS:'LOY3_LOAD_CART_SUCCESS',
    LOY3_LOAD_CART_FAILURE:'LOY3_LOAD_CART_FAILURE',

    CHANGE_PWD_SUCCESS: 'CHANGE_PWD_SUCCESS',

    CHECK_FACEBOOK_SUCCESS: 'CHECK_FACEBOOK_SUCCESS',
    CHECK_INSTAGRAM_SUCCESS: 'CHECK_INSTAGRAM_SUCCESS',
    CONNECT_FACEBOOK_SUCCESS: 'CONNECT_FACEBOOK_SUCCESS',
    CONNECT_FACEBOOK_FAILURE: 'CONNECT_FACEBOOK_FAILURE',
    CONNECT_INSTAGRAM_SUCCESS: 'CONNECT_INSTAGRAM_SUCCESS',
    CONNECT_INSTAGRAM_FAILURE: 'CONNECT_INSTAGRAM_FAILURE',
    DISCONNECT_FACEBOOK_SUCCESS: 'DISCONNECT_FACEBOOK_SUCCESS',


    LOGOUT: 'USERS_LOGOUT',

    FETCH_USER: 'FETCH_USER',
    GETALL_REQUEST: 'USERS_GETALL_REQUEST',
    GETALL_SUCCESS: 'USERS_GETALL_SUCCESS',
    GETALL_FAILURE: 'USERS_GETALL_FAILURE',

    DELETE_REQUEST: 'USERS_DELETE_REQUEST',
    DELETE_SUCCESS: 'USERS_DELETE_SUCCESS',
    DELETE_FAILURE: 'USERS_DELETE_FAILURE',
    GET_REGISTRATION_INFO: 'GET_REGISTRATION_INFO',

    LOY3_POINTS_UPDATE: 'LOY3_POINTS_UPDATE',

    RESEND_EMAIL_SUCCESS:'RESEND_EMAIL_SUCCESS',
    RESEND_EMAIL_FAILURE:'RESEND_EMAIL_FAILURE',

    SANDOS_FB_APP_ID: '914165251972686',
    SANDOS_FB_APP_SECRET: '26d24a0058ec4e239614f95ba8765faf',
    MARCONFORT_FB_APP_ID: '1692488844326620',
    MARCONFORT_FB_APP_SECRET: 'f372b08c19fe9163dcbda7009d8018c3',
    UPLOAD_FILE_SUCCESS:'UPLOAD_FILE_SUCCESS',

    INITIAL_MODAL_VISIBLE: 'INITIAL_MODAL_VISIBLE',
};
